import React from "react"
// react component for creating dynamic tables
import ReactTable from "react-table"

import * as Alert from "alertService"
import { APIPost, APIGet } from "services/APIRequest"
import UrlServer from "configs/UrlServer"
import { ErrorsCallback, SuccessCallback } from "alertService"
import { thaiBath } from "helpers/ConvertFormat"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsEmailHotAlertUpdate } from "store/actions"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// @material-ui/icons
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import EventNoteIcons from "@material-ui/icons/EventNote"
// import Dvr from "@material-ui/icons/Dvr";
// import Favorite from "@material-ui/icons/Favorite";
import DeleteForeverIcons from "@material-ui/icons/DeleteForever"
// core components
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select"
import Switch from "@material-ui/core/Switch"
import Badge from "components/Badge/Badge"
import Tooltip from "@material-ui/core/Tooltip";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle"
import tasksStyle from "assets/jss/material-dashboard-pro-react/components/tasksStyle";
const styles = {
  ...extendedFormsStyle,
  ...tasksStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  noConfirmedemail: {
    color: "red"
  },
  devType: {
    color: "#689F38"
  },
  tableH: {
    // marginTop: "30px",
    // marginBottom: "30px"
  }
}
class UserFromImportListManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      statusWaitingUpdate: true,
      dataListRaw: [],
      dataList: []
    }
  }
  componentDidMount() { 
    this.props.listsEmailHotAlertUpdate()
  }

  componentWillUpdate(nextProps, nextState) { 
    if (nextProps.listsEmailHotAlert !== nextState.dataListRaw) {
      var dataList = this.renderListData(nextProps)
      this.setState({
        statusWaitingUpdate: false,
        dataListRaw: nextProps.listsEmailHotAlert,
        dataList: dataList
      },()=>{
        Alert.LoadingClose()
        this.props.callbacksetTabIndex(0)
      })
    }
  }
  handleUserViewDetail = (indexData)=>{
    this.props.callbacksetTabIndex(1)
    this.props.callbackSetCurrentData(this.state.dataListRaw[indexData])
  }
  renderSingleEmail = (emails)=>{
    var ar = emails.split(",")
    return ar.map((data,index)=>{
      console.log(data)
      return (<div className="badge-space"><Badge color={"info"}>{data}</Badge></div>)
    }) 
   
  }
  renderListData = data => {
    return data.listsEmailHotAlert.map((CData, key) => {
      return {
        no: (key + 1),
        dealercode: CData.dealer_code,
        email: (<div> {this.renderSingleEmail(CData.emails)}</div>),
        // email: CData.user_data_id.email,
        // description: CData.description,
        // user_type:(
        //   <div className={this.props.classes.tableH}>
        //     <Badge color={"info"}>{CData.user_type_code}</Badge>
        //   </div>),
        // active: (
        //   <div>
        //     <Tooltip
        //         id="tooltip-top"
        //         title={ ((CData.active)?"ปิด":"เปิด") + " การใช้งานข้อรหัสนี้" }
        //         placement="top"
        //         classes={{ tooltip: this.props.classes.tooltip }}
        //       >
        //       <Switch
        //         checked={CData.active}
        //         onChange={e => {
        //           this.handleChangeActive(CData._id, CData.code ,!CData.active)
        //         }}
        //         disabled={CData.user_type_code === 0 ? true : false}
        //         classes={{
        //           switchBase: this.props.switchBase,
        //           checked: this.props.switchChecked,
        //           icon: this.props.switchIcon,
        //           iconChecked: this.props.switchIconChecked,
        //           bar: this.props.switchBar
        //         }}
        //       />
        //     </Tooltip>
        //   </div>
        // ),
        actions: (
          <div className="actions-right">
             
          </div>
        )
      }
    })
  }
  handleChangeActive = (id,name, status) => {
    Alert.QuestionCallback("คุณต้องการเปลี่ยนสถานะการใช้งานของ " + name + " เป็น "+ status +" ใช่หรือไม่?","blue",()=>{
      const dataToSend = {
        _id:id,
        active:status
      }
      APIPost( UrlServer.URL_POST_ACTIVE_PROJECT,dataToSend,(datas)=>{
          this.props.listsUserFromImportUpdate()
      })
    })
  }
  handleDeleteData = (id,  name) => {
    Alert.QuestionCallback("คุณต้องการลบ " + name + " ใช่หรือไม่?","red",()=>{
      const dataToSend = {
        _id:id,
      }
      APIPost( UrlServer.URL_POST_DELETE_PROJECT,dataToSend,(datas)=>{
        SuccessCallback(datas.message,null,()=>{
          this.props.listsUserFromImportUpdate()
        })
      })
    })
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card >
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <FormatListNumberedIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>รายการ Email Hot Alert นำเข้าระบบโดยการ Import</h4>
              </CardHeader>
              <CardBody>
                <span>จำนวน {thaiBath(this.state.dataList.length,false)} รายการ</span> 
                <ReactTable
                  className="table-scroll"
                  data={this.state.dataList}
                  filterable
                  columns={[
                    {
                      Header: "No.",
                      accessor: "no",
                      width: 150
                    },
                    {
                      Header: "dealer",
                      accessor: "dealercode"
                    },
                    {
                      Header: "E-Mail",
                      accessor: "email",
                    },
                    // {
                    //   Header: "User-Type",
                    //   accessor: "user_type"
                    // },
                    // {
                    //   Header: "สถานะเปิดใช้งาน",
                    //   accessor: "active",
                    //   filterable: false
                    // },
                    {
                      Header: "ตั้งค่าต่างๆ",
                      accessor: "actions",
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                  className="-striped -highlight"
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

function mapStateToProps({ listsEmailHotAlert }) {
  return {
    listsEmailHotAlert: listsEmailHotAlert
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsEmailHotAlertUpdate }
  )
)(UserFromImportListManagement)
